import { SpinRequestBuilder } from "ags/integration/builders/requests/spin-request-builder";
import { Contract } from "appworks/utils/contracts/contract";
import { ForceList } from "slotworks/debug/menu/force-list";

class AgsSpinForcer implements ForceList {
    protected results: Map<string, string> = new Map<string, string>();

    public setResults(results: Map<string, string>) {
        this.results = results;
    }

    public getList(): Contract<string[]> {
        return new Contract<string[]>((resolve) => {
            resolve(Array.from(this.results.keys()));
        });
    }

    public force(id: string): Contract<void> {
        const forceId: string = this.results.has(id) ? this.results.get(id) : id;
        SpinRequestBuilder.force = forceId;
        return Contract.empty();
    }
}

export const agsSpinForcer = new AgsSpinForcer();
